import { GlobalStyle } from "../../common/styles/global.js";
import { Navbar } from "../../common/components/Navbar.js";
import {
  HomeContent,
  ProjectsSection,
  ProjectsTitle,
  ProjectCard,
  ProjectImage,
  ProjectInfo,
  ProjectName,
  ProjectDescription,
  ProjectTechStack,
  ProjectLinks,
} from "../../common/styles/components.js";
import rudist from "../../assets/rudist.svg";
import wip from "../../assets/wip.svg";
import watchparty from "../../assets/watch-party.png"

export const Projects = () => {
  const projects = [
    {
      name: "Rudist",
      description:
        "Custom Redis-compatible server implemented in Rust, built as a deep dive into Redis internals and Rust’s capabilities. This project combines key Redis features with Rust’s safety and performance advantages, making it an ideal exploration of both systems programming and Redis architecture.",
      techStack:
        "Rust, Redis, Networking, Concurrency, Data Structures, Serialization",
      image: rudist,
      repoLink: "https://github.com/c3llus/rudist",
      blogLink:
        "https://blog.c3llus.dev/posts/rudist-redis-implementation-in-rust/",
    },
    // {
    //   name: "SQnotsoLite",
    //   description: "Attempted SQLite implementation in Rust.",
    //   techStack: "Rust, SQLite, File I/O",
    //   image: wip,
    //   repoLink: "https://github.com/c3llus/sqlnotsolite",
    //   blogLink:
    //     "https://blog.c3llus.dev/posts/sqlnotsolite-sqlite-implementation-in-rust/",
    // },
    {
      name: "Watch Party",
      description:
        "Real-time video synchronization platform enabling groups to watch videos together in perfect sync. Features WebSocket-based synchronization, room-based architecture, live chat, and guest access. Built with a bootstrapper's mindset, scalable microservices architecture that can deploy as a single executable or distributed system. Includes complete infrastructure-as-code setup with Terraform/Ansible for production deployment.",
      techStack: "Go, React, TypeScript, WebSocket, PostgreSQL, Redis, Docker, Terraform, Ansible, HLS Streaming, Microservices Architecture, Google Cloud Platform",
      image: watchparty,
      repoLink: "https://github.com/c3llus/watch-party",
      blogLink:
        "https://blog.c3llus.dev/posts/synchronized-distributed-watch-party/",
    },
    // {
    //   name: "Pixel Engine",
    //   description:
    //     "A lightweight 2D game engine built in Rust, designed to explore the foundational concepts of game engine development. Pixel Engine features custom rendering, entity management, and input handling, offering a modular framework for creating simple yet dynamic 2D games. This project demonstrates the power of Rust for performance-critical, real-time applications.",
    //   techStack: "Rust, Rendering, ECS (Entity-Component System), Input Handling",
    //   image: wip,
    //   repoLink: "https://github.com/c3llus/pixel-engine",
    //   blogLink:
    //     "https://blog.c3llus.dev/posts/building-a-pixel-based-game-engine/",
    // },
    {
      name: "Project Foxy",
      description:
        "Custom hypervisor operating at Ring -1 (VMX root mode) for stealth memory introspection below Windows 11. Implements Intel VT-x virtualization with Extended Page Tables (EPT) for undetectable memory access. Features custom UEFI bootloader that loads before OS initialization. Inspired by legendary Blue Pill research, this project explores the most challenging aspects of systems programming and hardware virtualization.",
      techStack: "C, x86-64 Assembly, Intel VT-x/VMX, UEFI, EPT, Hypervisor Development, Ring -1 Programming, Memory Virtualization",
      image: wip,
      repoLink: "https://github.com/c3llus/foxy",
      blogLink:
        "https://blog.c3llus.dev/posts/project-foxy/",
    },
    // {
    //   name: "GoForge",
    //   description:
    //     "Full-featured scaffolding for creating production-ready applications with modern open-source tools, swiftly.",
    //   techStack: "Go, Distributed Systems, Microservices Architecture, Observability, Containerization, CI/CD, Cloud Infrastructure, API Development",
    //   image: wip,
    //   repoLink: "https://github.com/c3llus-mirror/goforge",
    //   blogLink:
    //     "https://blog.c3llus.dev/posts/goforge-backend-boilerplate-for-rapid-development/",
    // },
    // {
    //   name: "BlockchainExplorer",
    //   description:
    //     "A real-time, multi-chain blockchain explorer that efficiently queries and presents blockchain data (transactions, blocks, addresses).",
    //   techStack:
    //     "Go, Blockchain, Distributed Systems, API Development, Data Indexing, Cloud Infrastructure",
    //   image: wip,
    //   repoLink: "https://github.com/c3llus-mirror/blockchainexplorer",
    //   blogLink:
    //     "https://blog.c3llus.dev/posts/blockchainexplorer-building-a-real-time-blockchain-explorer/",
    // },
    // ...other projects
  ];

  // const wipProjects =[]

  return (
    <>
      <GlobalStyle />
      <div className="main">
        <div id="mainbox">
          <Navbar />
          <HomeContent>
            <ProjectsSection>
              <ProjectsTitle>My Projects</ProjectsTitle>
              {projects.map((project, index) => (
                <ProjectCard key={index}>
                  <ProjectImage
                    src={project.image}
                    alt={project.name}
                  />
                  <ProjectInfo>
                    <ProjectName>{project.name}</ProjectName>
                    <ProjectDescription>{project.description}</ProjectDescription>
                    <ProjectTechStack>
                      <strong>Tech Stack:</strong> {project.techStack}
                    </ProjectTechStack>
                    <ProjectLinks>
                      <a
                        href={project.repoLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View on GitHub
                      </a>
                      <span> | </span>
                      <a
                        href={project.blogLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read Tech Blog
                      </a>
                    </ProjectLinks>
                  </ProjectInfo>
                </ProjectCard>
              ))}
            </ProjectsSection>
          </HomeContent>
        </div>
      </div>
    </>
  );
};
